// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"54a2dcc1","585":"02a888ea"}[chunkId] + ".chunk.js";
};